import { createPortal } from 'react-dom'
import JobToastStack from '@/components/JobToastStack'
import ToastStack from '@/components/ToastStack'
import { useBackgroundJobsStore } from '@/store/backgroundJobsStore'
import { useToastStore } from '@/store/toastStore'

/**
 * Shared bottom-right portal for background job toasts and global app toasts.
 * Job toasts render above global toasts so active work stays most visible.
 */
export default function BottomRightNotificationStack() {
  const hasJobs =
    useBackgroundJobsStore(
      (s) => Object.keys(s.serverById).length > 0 || s.synthetics.length > 0
    )
  const hasToasts = useToastStore((s) => s.toasts.length > 0)

  if (!hasJobs && !hasToasts) return null

  const shell = (
    <div
      className="fixed z-50 flex flex-col gap-2 max-md:left-3 max-md:right-3 max-md:bottom-[max(0.75rem,calc(env(safe-area-inset-bottom,0px)+0.75rem))] bottom-2 left-2 right-2 sm:bottom-4 sm:left-auto sm:right-4 sm:items-end pointer-events-none"
      aria-label="Notifications"
    >
      <div className="flex flex-col gap-2 items-stretch sm:items-end pointer-events-auto">
        <JobToastStack embedded />
        <ToastStack embedded />
      </div>
    </div>
  )

  return createPortal(shell, document.body)
}
